import React from 'react';
import Tabs from '@ertelecom/ui-react/components/tabs/tabs';
import Tab from '@ertelecom/ui-react/components/tabs/tab';
import { Container, TabContainer, Content, Image, Text, Title, Wrapper } from './styled';

const Cases = ({ activeTab, features }) => {
    const activeIndex = features.findIndex(item => item.key === activeTab);
    return <Wrapper>
        <Container id='cases'>
            <Tabs activeTab={features[activeIndex] ? features[activeIndex].label : 'Дети'}>
                {features.map(({ label, key, title, description, image }) => <Tab label={label} key={key}>
                    <TabContainer>
                        <Content>
                            <Title>
                                {title}
                            </Title>
                            <Text>
                                {description}
                            </Text>
                        </Content>
                        <Image src={image}/>
                    </TabContainer>
                </Tab>)}
            </Tabs>
        </Container>
    </Wrapper>;
};

export default Cases;
